import axios from 'axios';
import config from '../config';
import { CreateRouteCardRequestBody, RouteCard } from '../interfaces';

export const postRouteCard = (request: CreateRouteCardRequestBody): Promise<RouteCard> => {
    return axios.post(`${config.API_URL}/route-cards`, request).then((response: any) => {
        return response.data.data.routeCard;
    });
};
